import React from 'react';
import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="border-t border-[#1E3352] bg-[#0A1520] mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-lg bg-[#00C9A7] flex items-center justify-center">
                <span className="text-[#0F1B2D] font-black text-sm">M</span>
              </div>
              <span className="font-extrabold text-lg text-white tracking-tight">MANGQASHA IT SOLUTIONS</span>
            </div>
            <p className="text-[#64748B] text-sm leading-relaxed max-w-xs">
              Enterprise resource planning software built for growing businesses. Finance, HR, inventory, CRM — all in one platform.
            </p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-[#64748B] mb-4">Product</p>
            <ul className="space-y-2.5">
              {['Products', 'Social Selling', 'Book a Demo', 'Store']?.map((item) => (
                <li key={item}>
                  <Link href={`/${item?.toLowerCase()?.replace(' ', '-')}`} className="text-sm text-[#94A3B8] hover:text-white transition-colors">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-[#64748B] mb-4">Company</p>
            <ul className="space-y-2.5">
              {['About', 'Customers', 'Blog', 'Contact']?.map((item) => (
                <li key={item}>
                  <span className="text-sm text-[#94A3B8] cursor-default">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-[#1E3352] flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-[#64748B]">© 2026 MANGQASHA IT SOLUTIONS. All rights reserved.</p>
          <div className="flex gap-4">
            <span className="text-xs text-[#64748B] cursor-default">Privacy Policy</span>
            <span className="text-xs text-[#64748B] cursor-default">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
